import React from 'react';
import { CtaButton } from '../CtaButton';
const questions = ['What is it worth to avoid just one clinical decision made with uncertainty?', 'What is it worth to get back the hours you currently spend searching through guidelines?', 'What is it worth to walk into a consultation knowing exactly what your next step should be?'];
export function Reflection() {
  return <section className="w-full bg-cream px-4 py-14 sm:px-6 sm:py-20" data-id="element-262" data-mp="3ro76fxpr8mgi">
      <div className="mx-auto w-full max-w-2xl text-center" data-id="element-263" data-mp="3rqbb4hvh9phu">
        <h2 className="font-display text-[26px] font-extrabold leading-tight text-ink sm:text-4xl" data-id="element-264" data-mp="3nnogk97f9qgy">
          Think about this for a moment…
        </h2>

        <ul className="mt-8 flex flex-col gap-3 text-left" data-id="element-265" data-mp="3dwtryy6peesc">
          {questions.map(question => <li key={question} className="border-l-2 border-blood bg-white/70 px-4 py-3.5 text-[15px] font-medium leading-relaxed text-ink sm:text-base" data-id="element-266" data-mp="f6tnflgffkg2">
              {question}
            </li>)}
        </ul>

        <p className="mt-8 text-[15px] leading-relaxed text-graphite/80 sm:text-base" data-id="element-267" data-mp="ud5jen72ic7w">
          Hypertension Route costs less than a single medical consultation in
          many countries — but it can become a clinical reference you’ll use
          across hundreds of consultations for years.
        </p>

        <div className="mt-8 flex justify-center" data-id="element-268" data-mp="pk2n47awooo0">
          <CtaButton label="I want this clarity in every consultation" data-id="element-269" data-mp="bluxylk42rne" />
        </div>
      </div>
    </section>;
}